import _ from 'lodash'

import VALUES from 'core/data-model/constants/values'

import { isNil, isNotNil } from 'core/service/lib/type-check'
import { isValidAge } from 'core/service/insured/birthdate'
import { createSelector } from 'reselect'
import {
  getSelectedDisplayProduct,
  getSelectedDisplayProductCode,
  getDisplayProducts,
} from 'quick-quote/product-selection/selectors'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import DEFAULTS from 'core/data-model/constants/defaults'

import {
  getSumAssured$,
  getSelectedRiders,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
} from 'quick-quote/product-common/coverage-plan/selectors'
import { getAge } from 'quick-quote/insured-information/selectors'

export const canProceedToBenefitIllustration = createSelector(
  getSumAssured$,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
  getSelectedRiders,
  canProceedToCoveragePlan,
  getSelectedDisplayProduct,
  (
    sumAssured$,
    basicPremium,
    totalPremium$,
    basicPlanErrorMessage,
    selectedRiders,
    canProceedToCoveragePlan,
    selectedDisplayProduct
  ) => {
    const selectedRiderInvalidMessages = selectedRiders.filter((rider) =>
      isNotNil(rider.errors.find((error) => error.type === VALUES.VALIDATION))
    )

    const canProceed =
      canProceedToCoveragePlan &&
      sumAssured$.isOk &&
      basicPremium.isOk &&
      totalPremium$.isOk &&
      _.isEmpty(selectedRiderInvalidMessages) &&
      _.isEmpty(basicPlanErrorMessage)
    if (selectedDisplayProduct.type === VALUES.CAMPAIGN_PRODUCT_TYPE) {
      const selectedRiderCodes = selectedRiders.map((rider) => rider.code)
      return (
        canProceed &&
        selectedDisplayProduct.requiredRiders != null &&
        selectedDisplayProduct.requiredRiders.every((riderCode) => {
          return selectedRiderCodes.indexOf(riderCode) > -1
        })
      )
    }
    return canProceed
  }
)

export const getSelectedProductLifeReadySIO = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case VALUES.LIFEREADY_SIO_CODE.LIFEREADY18_HIGHER_SIO:
      return VALUES.LIFEREADY_SIO_CODE.LIFEREADY18_UNDER_SIO
    case VALUES.LIFEREADY_SIO_CODE.LIFEREADY99_HIGHER_SIO:
      return VALUES.LIFEREADY_SIO_CODE.LIFEREADY99_UNDER_SIO
    default:
      return productCode
  }
})

export const getSelectableProductiShieldSIO = createSelector(getAge, getDisplayProducts, (age, products) => {
  const productGroup = _.filter(products, (product) =>
    _.includes(Object.values(VALUES.ISHIELD_SIO_CODE), _.get(product, 'code'))
  )
  const validProducts = _.filter(productGroup, (product) => isValidAge(age.value, age.unit, _.get(product, 'entryAge')))
  const validProductCodes = validProducts.map((product) => product.code)

  return validProductCodes
})
